__turbopack_context__.v({
  "hero-section-company-admin": "hero-section-company-admin-module-scss-module__NdNiza__hero-section-company-admin",
  "hero-section-company-admin__action": "hero-section-company-admin-module-scss-module__NdNiza__hero-section-company-admin__action",
  "hero-section-company-admin__description": "hero-section-company-admin-module-scss-module__NdNiza__hero-section-company-admin__description",
});
